import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LangService {
    private langSubject = new BehaviorSubject<string>('es');
    lang$ = this.langSubject.asObservable();

    setLang(lang: string): void {
        this.loadLocalizationData(lang);  // Cargar datos de localización al cambiar el idioma
        this.langSubject.next(lang);
    }

    // private loadLocalizationData(lang: string): void {
    //     const localePath = `@angular/common/locales/${lang}`;

    //     if (!localePath) return; 
    //     import(localePath).then(localeModule => {
    //         import(`${localePath}/extra`).then(extraModule => {
    //             localeModule.default && extraModule.default && registerLocaleData(localeModule.default, lang, extraModule.default);
    //         });
    //     });
    // }
    private async loadLocalizationData(lang: string): Promise<void> { //TODO
        // try {
        //   const localeModule = await import(`@angular/common/locales/${lang}`);
        // //   const extraModule = await import(`/locales/extra/${lang}`); // Si es necesario
    
        //   if (localeModule.default /*&& extraModule.default*/) {
        //     registerLocaleData(localeModule.default, lang/*, extraModule.default*/);
        //   }
        // } catch (error) {
        //   console.error(`Error cargando datos de localización para ${lang}:`, error);
        // }
      }
}